import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "3 3 18 19",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.800 4.289 C 14.629 4.324,14.423 4.523,10.769 8.173 C 8.164 10.775,6.892 12.073,6.839 12.183 C 6.740 12.386,6.739 12.612,6.837 12.820 C 6.888 12.930,8.109 14.175,10.766 16.826 C 14.501 20.553,14.626 20.674,14.810 20.711 C 15.390 20.830,15.830 20.390,15.711 19.810 C 15.674 19.626,15.560 19.508,12.117 16.060 L 8.561 12.500 12.117 8.940 C 15.569 5.483,15.673 5.374,15.712 5.189 C 15.832 4.604,15.389 4.167,14.800 4.289 ",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgCaretLeft;
